import { filter, Observable, of, take } from "rxjs";
import { Injectable } from "@angular/core";
import { MissionPartner } from "../sign-up/signup.types";
import { MissionPartnerProfileFactory } from "./mission-partner-profile.factory";
import * as MissionPartnerActions from "./store/mission-partner-profile.action";
import { LoginService } from "../../pages/login-page/login-page-data/login.service";
import { selectMissionPartnerProfile } from "./store/mission-partner-profile.selectors";
import { Store } from "@ngrx/store";
import { MissionPartnerProfileState, missionPartnerProfileFeatureName } from "./store/mission-partner-profile.reducer";

@Injectable({
  providedIn: "root",
})
export class MissionPartnerProfileResolver {
  constructor(
    private loginService: LoginService,
    private factory: MissionPartnerProfileFactory,
    private readonly store: Store<{ [missionPartnerProfileFeatureName]: MissionPartnerProfileState }>,
  ) {}

  resolve(): Observable<MissionPartner | undefined> {
    if (this.loginService.isAuthenticated()) {
      this.store.dispatch(MissionPartnerActions.loadMissionPartnerProfile());
      return this.getFromStoreOrAPI();
    }
    return of(this.factory.getNewInstance());
  }

  getFromStoreOrAPI(): Observable<MissionPartner | undefined> {
    return this.store.select(selectMissionPartnerProfile).pipe(
      filter((profile) => {
        return !!profile;
      }),
      take(1),
    );
  }
}
